export const carouselImages = [
  {
    id: 1,
    img: "SBD/hair5.jpg",
    title: "Fabulous",
    label: "Shop Now",
    path: "/shop",
  },
  {
    id: 2,
    img: "SBD/hair6.jpg",
    title: "Trends",
    label: "Shop Now",
    path: "/shop",
  },
  {
    id: 3,
    img: "SBD/hair9.jpg",
    title: "Collections",
    label: "Shop Now",
    path: "/shop",
  },
];

export const productData = [
  {
    id: 1,
    img: "https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fGhhaXJ8ZW58MHx8MHx8fDA%3D",
    title: "Twirly Curls",
    price: 120,
    count: 100,
    slug: "twirly-curls",
    createdAt: "January 23, 2024",
  },
  {
    id: 2,
    img: "https://www.azedw-react.wp-ts.com/assets/images/shop/img-6.jpg",
    title: "Human Hair",
    price: 130,
    count: 180,
    slug: "human-hair",
    createdAt: "January 5, 2024",
  },
  {
    id: 3,
    img: "https://www.azedw-react.wp-ts.com/assets/images/shop/img-3.jpg",
    title: "Blonde Curls",
    price: 210,
    count: 156,
    slug: "blonde-curls",
    createdAt: "Febuary 14, 2024",
  },
  {
    id: 4,
    img: "https://www.azedw-react.wp-ts.com/assets/images/shop/img-6.jpg",
    title: "Brown Braids",
    price: 109,
    count: 19,
    slug: "brown-braids",
    createdAt: "April 23, 2024",
  },
  {
    id: 5,
    img: "https://www.azedw-react.wp-ts.com/assets/images/shop/img-5.jpg",
    title: "Gold Blonde Curls",
    price: 488,
    count: 48,
    slug: "gold-blonde-curls",
    createdAt: "September 23, 2023",
  },
  {
    id: 6,
    img: "https://www.azedw-react.wp-ts.com/assets/images/shop/img-6.jpg",
    title: "Black Twirls",
    price: 100,
    count: 10,
    slug: "black-twirls",
    createdAt: "March 23, 2024",
  },
];
